// extracted by mini-css-extract-plugin
module.exports = {"iframe-close-button":"default_iframe-close-button__-yncy"};